/**
 * inbox requests model
 */
import Backbone from 'backbone';
import { reqQueryString } from './inboxConstants';
import { imageVersionQueryString } from 'utils/userSocialProfileImage/profileImageConstantsV2';

const InboxRequests = Backbone.Model.extend({
    backend: 'gcapi',

    initialize: function() {
        this.limit = 2;
    },

    url: function() {
        return `/web-gateway/inbox/v2/requests?limit=${this.limit}&${reqQueryString}&${imageVersionQueryString}`;
    },

    parse: function(response) {
        this.set('nextCursor', response.nextCursor);
        this.set('requests', response.requests);
        this.set('profileInfos', response.profileInfos);
    }
});

export default InboxRequests;
